import menuClasses from '@/components/ui/Menu/Menu.module.scss'
import triggerClasses from './Trigger.module.scss'
import menuItemClasses from './MenuItem.module.scss'
import { MenuOwnProps } from '@mui/base/Menu'
import clsx from 'clsx'
import { ReactComponent as ChevronIcon } from '@/assets/icons/chevron-right.svg'
import { MenuButtonOwnerState, MenuButtonProps } from '@mui/base/MenuButton'
import { ReactNode } from 'react'
import { MenuItemOwnerState, MenuItemOwnProps } from '@mui/base/MenuItem'
import { Placement } from '@/types'

export const useSlotProps = (placement: Placement): MenuOwnProps['slotProps'] => ({
  root: () => ({
    className: menuClasses.root,
    placement,
  }),
  listbox: () => ({
    className: menuClasses.listbox,
  }),
})

const Chevron = ({ isActive }: { isActive: boolean }) => {
  const className = clsx(triggerClasses.chevron, {
    [triggerClasses.open]: isActive,
  })

  return (
    <div className={className}>
      <ChevronIcon />
    </div>
  )
}
export const useTriggerSlotProps = (StartIcon: ReactNode): MenuButtonProps['slotProps'] => ({
  root: (ownerState: MenuButtonOwnerState) => ({
    StartIcon,
    EndIcon: <Chevron isActive={ownerState.open} />,
    color: 'neutral',
    isActive: ownerState.open,
    className: clsx(triggerClasses.root, {
      [triggerClasses.active]: ownerState.open,
    }),
  }),
})

export const useMenuItemSlotProps = (): MenuItemOwnProps['slotProps'] => ({
  root: (ownerState: MenuItemOwnerState) => ({
    className: clsx(menuItemClasses.root, {
      [menuItemClasses.focused]: ownerState.focusVisible,
    }),
  }),
})
